import React from 'react';
import { InvestorGuide } from './pages/InvestorGuide';
interface AppProps {
  screenshotTone?: 'mono' | 'color';
  showStepNav?: boolean;
  stepLayout?: 'alternating' | 'aligned';
}
export function App({
  screenshotTone = 'mono',
  showStepNav = true,
  stepLayout = 'alternating'
}: AppProps) {
  return <InvestorGuide screenshotTone={screenshotTone} showStepNav={showStepNav} stepLayout={stepLayout} data-id="element-0" data-mp="3fa88j72bos5w" />;
}